import { ChatUser, User } from '../types';

export const userToChatUser = (user: User): ChatUser => {
  return {
    uid: user.uuid,
    name: user.first_name + ' ' + user.last_name,
    avatarUrl: user.photo?.url,
    email: user.email,
    phone: user.phone,
    gender: user.gender || '',
    isManager: false,
    online: false,
    lastSeen: '',
  };
};
